/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Competition} from "./Competition";
import {Venue} from "./Venue";
import {StageSpriteUtils} from "../shared/StageSpriteUtils";

export class CompEvent {

  private static readonly STATUS_PLANNING: number = 0;
  private static readonly STATUS_READY: number = 1;
  private static readonly STATUS_ACTIVE: number = 2;
  private static readonly STATUS_COMPLETE: number = 3;

  public competition: Competition;
  public venue: Venue;

  public formattedStartDate: string;
  public formattedEndDate: string;

  public eventAccess: EventAccess;

  constructor(public id: string,
              public startDate: string,
              public endDate: string,
              public status: number,
              public language: string,
              public tourId: string,
              public eventType: number,
              public name: string = null,
              public storeUrl: string = null) {

    if (startDate) {
      this.formattedStartDate = StageSpriteUtils.formatLongDate(startDate);
    }
    if (endDate) {
      this.formattedEndDate = StageSpriteUtils.formatLongDate(endDate);
    }
  }

  public isComplete() {
    return this.status == CompEvent.STATUS_COMPLETE;
  }

  static fromSnapshot(snap: any) {
    return CompEvent._fromSnapshot(snap.key, snap.val());
  }

  static fromJson(id: string, data: any) {
    if (!data) {
      return null;
    }

    return this._fromSnapshot(id, data);
  }

  public static _fromSnapshot(key: string, {competition, endDate, language, startDate, status, tourId, venue, name,
    eventType, storeUrl, accessOptions}) {

    let event = new CompEvent(key, startDate, endDate, status, language, tourId, eventType, name, storeUrl);

    event.competition = new Competition(competition.key, competition.name, null, null, null);
    event.venue = new Venue(venue.key, venue.name, venue.city);
    event.eventAccess = EventAccess.fromSnapshot(accessOptions);

    return event;
  }
}

export class EventAccess {

  constructor(public isCheckin: boolean = false,
              public isFree: boolean = false,
              public isPurchase: boolean = false,
              public isChatEnabled: boolean = false,
              public isFeedEnabled: boolean = true) {
  }

  static fromSnapshot({
                        isCheckin = false,
                        isFree = false,
                        isPurchase = false,
                        isChatEnabled = false,
                        isFeedEnabled = true
                      } = {}) {
    return new EventAccess(isCheckin, isFree, isPurchase, isChatEnabled, isFeedEnabled);
  }
}



// WEBPACK FOOTER //
// ./src/models/CompEvent.ts